export const TEXTS = {
  DOWNLOAD: 'Скачать',
  IN_PROGRESS: 'Отчет формируется...',
};
